"use client";

import { CSSProperties, ReactElement, ReactNode } from "react";
import { cn } from "@/lib/utils";
interface NeonColorsProps {
  firstColor: string;
  secondColor: string;
}
interface NeonGradientCardProps {
  /**
   * @default <div />
   * @type ReactElement
   * @description
   * The component to be rendered as the card
   * */
  as?: ReactElement;
  /**
   * @default ""
   * @type string
   * @description
   * The className of the card
   */
  className?: string;

  /**
   * @default ""
   * @type ReactNode
   * @description
   * The children of the card
   * */
  children?: ReactNode;

  /**
   * @default 5
   * @type number
   * @description
   * The size of the border in pixels
   * */
  borderSize?: number;

  /**
   * @default 20
   * @type number
   * @description
   * The size of the radius in pixels
   * */
  borderRadius?: number;

  /**
   * @default "{ firstColor: '#ff00aa', secondColor: '#00FFF1' }"
   * @type string
   * @description
   * The colors of the neon gradient
   * */
  neonColors?: NeonColorsProps;
  [key: string]: any;
}
export const NeonGradientCard: React.FC<NeonGradientCardProps> = ({
  className,
  children,
  borderSize = 1,
  borderRadius = 20,
  neonColors = {
    firstColor: "#3970ff",
    secondColor: "#3970ff"
  },
  ...props
}) => {
  return <div style={{
    "--border-size": `${borderSize}px`,
    "--border-radius": `${borderRadius}px`,
    "--neon-first-color": neonColors.firstColor,
    "--neon-second-color": neonColors.secondColor
  } as CSSProperties} className={cn("relative z-10 size-full rounded-[var(--border-radius)] border border-border bg-white", className)} {...props}>
      <div className={cn("relative size-full min-h-[inherit] rounded-[var(--border-radius)] bg-white p-5")}>
        {children}
      </div>
    </div>;
};